<template>
  <div class="service-dynamic">
    <div class="wrap-aside">
          <div class="aside-title">
            <span>{{ $t('asm_feedBack_dynamic.chu_li_dong_tai') }}</span>
          </div>
          <div class="flow">
            <ul>
              <li v-for="(item, index) in orderLog" :key="index">
                <div class="ub tit ub-xc">
                  <div class="dit1" :class="{ dit: index === 0 }">
                    <div></div>
                  </div>
                  <h1>{{ momentAmPm($momentLocal(item.operateTime)) }}</h1>
                </div>
                <div>
                  <p>{{ $t('asm_feedBack_dynamic.shen_pi_jie_dian') }}：{{item.flowNodeName}}</p>
                  <p v-if="item.approvalResult">{{ $t('asm_feedBack_dynamic.shen_pi_jie_guo') }}：{{ item.approvalResult || '-'}}</p>
                  <p v-if="item.approvalResult">{{ $t('asm_feedBack_dynamic.shen_pi_yi_jian') }}：{{ item.opinion || '-'}}</p>
                  <p>{{ $t('asm_feedBack_dynamic.cao_zuo_ren') }}：{{ item.userName || '-'}}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
/**
 * 服务动态
 */
export default {
  name: '',
  mixins: [],
  props: {
    feedBackId: [Number, String],
  },
  data() {
    return {
      orderLog: []
    };
  },
  computed: {},

  methods: {
    getStateList() {
      this.$getJSON(apis.feedbackLogList, { feedBackId: this.feedBackId }).then((res) => {
        this.orderLog = res.data || [];
      });
    },
  },
  mounted() {
    this.getStateList();
  },
};
</script>

<style lang="scss" scoped>
.service-dynamic{
  overflow-y:auto ;
  .wrap-aside {
    // width: 350px;
    // width: 100%;
    // background-color: #ffffff;
    // margin-left: 20px;
    // padding-bottom: 10px;
    width: 350px;
    background-color: #ffffff;
    margin-left: 20px;
    padding-bottom: 10px;
    .aside-title {
      line-height: 40px;
      height: 40px;
      padding-left: 20px;
      color: #495057;
      font-weight: 500;
      font-size: 12px;
      border-bottom: 1px solid #eef2f8;
      margin-bottom: 10px;
    }
    .flow {
      padding: 25px 0 25px 32px;
      // height: 760px;
      overflow-y: auto;
      .dit1.dit {
        background-color: #ffffff;
        padding: 5px;
        width: 20px;
        div {
          background-color: #4a90e2;
          width: 11px;
          height: 11px;
          border-radius: 7px;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 3px;
            top: 3px;
            z-index: 1;
            width: 5px;
            height: 5px;
            border-radius: 6px;
            background-color: #ffffff;
          }
        }
      }

      .dit1 {
        background-color: #ffffff;
        padding: 3px 6px;
        width: 20px;
        div {
          background-color: #8c8c8c;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          position: relative;
        }
      }
      ul > li {
        padding: 14px 20px 44px 23px;
        border-left: 1px solid #bfbfbf;
        position: relative;
        word-break: break-all;
        box-sizing: content-box;
        &:last-child {
          border-left: 1px solid #ffffff;
        }
        .tit {
          position: absolute;
          top: -12px;
          left: -11px;
        }
        h1 {
          color: #495057;
          font-size: 12px;
          line-height: 24px;
          margin-left: 14px;
          font-weight: 500;
        }
        p {
          font-size: 12px;
          color: #6c757d;
          line-height: 22px;
        }
      }
    }
  }
}

</style>
